import { createFileRoute } from '@tanstack/react-router';
import { useActiveProgramId } from '@interxfi/api-client';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { RequiresAccess } from '@interxfi/design-system/access-context';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { Button } from '@interxfi/design-system/components/button';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table';
import PlusIcon from '@interxfi/design-system/icons/react/icon-plus';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../components/router/router-tabbed-navigation';
import { DevelopersTabRail } from '../../../../../features/developer/developers-tab-rail';
import { RelayTargetCreateDrawer } from '../../../../../features/relay/target/relay-target-create-drawer';
import { RelayTargetsTable } from '../../../../../features/relay/target/relay-targets-table';
import { getPageHead } from '../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/developer/webhook/_webhook/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.Developers,
      label: 'Webhooks',
      order: 2,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.Developers>,
  head: () => getPageHead('Webhooks'),
  component: WebhookList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <DevelopersTabRail
      actions={
        <HorizontalStack align="end" blockAlign="center" gap={2} wrap="nowrap">
          <RequiresAccess write>
            <RelayTargetCreateDrawer trigger={<Button affixIcon={<PlusIcon aria-hidden />} aria-label="New Webhook" size="small" />} />
          </RequiresAccess>
          {filter}
        </HorizontalStack>
      }
    />
  );
}

function WebhookList() {
  const activeProgramId = useActiveProgramId();

  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <RelayTargetsTable destinationType="url" HeaderActions={TableHeader} programId={activeProgramId} renderWhenEmpty="No Webhooks" />
      </PageLayout.Section>
    </PageLayout>
  );
}
